import React from 'react';
import humanizeValue from '@utils/overview/humanizeValue';
import { getMetricMetaByKey } from '@src/utils/metrics/metricHelpers';
import {
  MetricValueWrapper,
  MetricTileWrapper,
  MetricValue,
  MetricUnit,
  MetricNameWrapper,
} from './styled';
import { formatPlayTime, getSpiColor } from '../common/utils';

const MetricTile = ({ metric, metricValue }) => {
  const metricInfo = getMetricMetaByKey({ metricKey: metric });
  const value = humanizeValue(metricValue, metric, metricInfo.unit);
  // Total minutes needs to be shown as Hours, Minutes and Seconds
  // For Ex. 3h 30m 10s
  const isTotalMinutes = metric === 'MinutesPlayed';
  if (isTotalMinutes) {
    value.humanizedNumber = formatPlayTime(metricValue);
    value.humanizedUnit = '';
  }
  const textStyle = (value) => {
    const styles = getSpiColor(value);
    const spiStyle = { color: `${styles}` };
    return spiStyle;
  };
  return (
    // selected is set to false for beta phase. selection to be enabled in future phase
    <MetricTileWrapper id={metricInfo.displayName} selected={false}>
      <MetricNameWrapper>{metricInfo.short}</MetricNameWrapper>
      <MetricValueWrapper>
        {metricInfo.short === 'SPI' ? (
          <MetricValue style={textStyle(value.humanizedNumber)}>
            {value.humanizedNumber}
          </MetricValue>
        ) : (
          <MetricValue>{value.humanizedNumber}</MetricValue>
        )}
        <MetricUnit>{value.humanizedUnit}</MetricUnit>
      </MetricValueWrapper>
    </MetricTileWrapper>
  );
};

export default MetricTile;
